import React from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableFooter,
  TablePagination,
} from '@material-ui/core';
import { map } from 'lodash';
import TablePaginationActions from '../TablePaginationActions';
import { LIST_PAGE_COUNT } from '../../data/common';
import UserReservationTableRow from './UserReservationTableRow';

const UserReservationTable = (props) => {
  const { userReservations, total, openDetail, pageNum, setPageNum } = props;

  return (
    <TableContainer component={Box}>
      <Table aria-label="customized table">
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>預約物件</TableCell>
            <TableCell>預約人</TableCell>
            <TableCell>預約日期</TableCell>
            <TableCell>開始時間</TableCell>
            <TableCell>結束時間</TableCell>
            <TableCell>預約人數</TableCell>
            <TableCell>預計總價</TableCell>
            <TableCell align="right">功能</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {map(userReservations, (userReservation) => (
            <UserReservationTableRow
              key={userReservation.id}
              userReservation={userReservation}
              openDetail={openDetail}
            />
          ))}
        </TableBody>

        <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[LIST_PAGE_COUNT]}
              colSpan={9}
              count={total}
              rowsPerPage={LIST_PAGE_COUNT}
              page={pageNum - 1}
              SelectProps={{
                inputProps: { 'aria-label': 'rows per page' },
                native: true,
              }}
              onChangePage={(event, currentPage) => {
                setPageNum(currentPage + 1);
              }}
              ActionsComponent={TablePaginationActions}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  );
};

export default UserReservationTable;
